import { apiClient } from '../client';
import { Interest, CreateInterestDto, UpdateInterestDto } from '../../types';

export const interestsService = {
  // Get all interests
  async getAllInterests(): Promise<Interest[]> {
    const response = await apiClient.get('/interests');
    return response.data;
  },

  // Get a single interest by ID
  async getInterestById(id: string): Promise<Interest> {
    const response = await apiClient.get(`/interests/${id}`);
    return response.data;
  },

  // Create a new interest
  async createInterest(data: CreateInterestDto): Promise<Interest> {
    const response = await apiClient.post('/interests', data);
    return response.data.data;
  },

  // Update an interest
  async updateInterest(id: string, data: UpdateInterestDto): Promise<Interest> {
    const response = await apiClient.put(`/interests/${id}`, data);
    return response.data.data;
  },

  // Delete an interest (soft delete)
  async deleteInterest(id: string): Promise<void> {
    await apiClient.delete(`/interests/${id}`);
  },

  // Upload image (for image_url)
  async uploadImage(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', 'image');
    
    const response = await apiClient.post('/interests/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },

  // Upload icon (for icon_url)
  async uploadIcon(file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('type', 'icon');
    
    const response = await apiClient.post('/interests/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    
    return response.data;
  },
};